// @ts-nocheck
import Vue from 'vue'
import VueRouter, { RouteConfig, Route } from 'vue-router'
import { Auth, DataStore } from 'aws-amplify'
import { mutateTenant } from '@/store/tenant'

const LoginView = () =>
  import(/* webpackChunkName: "login" */ '@/views/Login.vue')
const UsersView = () =>
  import(/* webpackChunkName: "users" */ '@/views/Users.vue')
const AdminView = () =>
  import(/* webpackChunkName: "admin" */ '@/views/Admin.vue')
const PagesLayoutView = () =>
  import(/* webpackChunkName: "pages" */ '@/views/PagesLayout.vue')
const PagesView = () =>
  import(/* webpackChunkName: "pages" */ '@/views/Pages.vue')
const PageEditView = () =>
  import(/* webpackChunkName: "pages" */ '@/views/PageEdit.vue')
const DistrictsLayoutView = () =>
  import(/* webpackChunkName: "districts" */ '@/views/DistrictsLayout.vue')
const DistrictsView = () =>
  import(/* webpackChunkName: "districts" */ '@/views/Districts.vue')
const DistrictChecklistsView = () =>
  import(/* webpackChunkName: "districts" */ '@/views/DistrictChecklists.vue')
const DistrictChecklistEditView = () =>
  import(
    /* webpackChunkName: "districts" */ '@/views/DistrictChecklistEdit.vue'
  )
const DistrictChecklistItemEditView = () =>
  import(
    /* webpackChunkName: "districts" */ '@/views/DistrictChecklistItemEdit.vue'
  )
const DistrictInfosView = () =>
  import(/* webpackChunkName: "districts" */ '@/views/DistrictInfos.vue')
const DistrictInfoEditView = () =>
  import(/* webpackChunkName: "districts" */ '@/views/DistrictInfoEdit.vue')
const MediasLayoutView = () =>
  import(/* webpackChunkName: "medias" */ '@/views/MediasLayout.vue')
const MediasView = () =>
  import(/* webpackChunkName: "medias" */ '@/views/Medias.vue')
const MediaEditView = () =>
  import(/* webpackChunkName: "medias" */ '@/views/MediaEdit.vue')

import { Role } from '@/lib/Role'
import { mutateSnackbar } from '@/store/snackbar'

Vue.use(VueRouter)

export const routes: RouteConfig[] = [
  {
    name: 'logout',
    path: '/logout'
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/users',
    name: 'users',
    component: UsersView,
    meta: {
      authorizedTo: [Role.Admin, Role.Tenant]
    }
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminView,
    meta: {
      authorizedTo: [Role.Admin]
    }
  },
  {
    path: '/pages',
    component: PagesLayoutView,
    children: [
      {
        path: '',
        name: 'pages',
        component: PagesView,
        meta: {
          authorizedTo: [Role.Admin, Role.Tenant, Role.Author, Role.Contributor]
        }
      },
      {
        path: ':pageId',
        name: 'page-edit',
        component: PageEditView,
        meta: {
          authorizedTo: [Role.Admin, Role.Tenant, Role.Author, Role.Contributor]
        }
      }
    ]
  },
  {
    path: '/districts',
    component: DistrictsLayoutView,
    children: [
      {
        path: '',
        name: 'districts',
        component: DistrictsView,
        meta: {
          authorizedTo: [Role.Admin, Role.Tenant, Role.Author, Role.Contributor]
        }
      },
      {
        path: ':districtId/checklists',
        name: 'district-checklists',
        component: DistrictChecklistsView,
        meta: {
          authorizedTo: [Role.Admin, Role.Tenant, Role.Author, Role.Contributor]
        }
      },
      {
        path: ':districtId/checklist/:checklistId',
        name: 'district-checklist-edit',
        component: DistrictChecklistEditView,
        meta: {
          authorizedTo: [Role.Admin, Role.Tenant, Role.Author, Role.Contributor]
        }
      },
      {
        path: ':districtId/checklist/:checklistId/item/:itemId',
        name: 'district-checklist-item-edit',
        component: DistrictChecklistItemEditView,
        meta: {
          authorizedTo: [Role.Admin, Role.Tenant, Role.Author, Role.Contributor]
        }
      },
      {
        path: ':districtId/infos',
        name: 'district-infos',
        component: DistrictInfosView,
        meta: {
          authorizedTo: [Role.Admin, Role.Tenant, Role.Author, Role.Contributor]
        }
      },
      {
        path: ':districtId/infos/:infoId',
        name: 'district-info-edit',
        component: DistrictInfoEditView,
        meta: {
          authorizedTo: [Role.Admin, Role.Tenant, Role.Author, Role.Contributor]
        }
      }
    ]
  },
  {
    path: '/medias',
    component: MediasLayoutView,
    children: [
      {
        path: '',
        name: 'medias',
        component: MediasView,
        meta: {
          authorizedTo: [Role.Admin, Role.Tenant, Role.Author]
        }
      },
      {
        path: ':mediaId',
        name: 'media-edit',
        component: MediaEditView,
        meta: {
          authorizedTo: [Role.Admin, Role.Tenant, Role.Author]
        }
      }
    ]
  },
  {
    path: '/dashboard',
    name: 'dashboard'
  },
  {
    path: '*',
    redirect: { name: 'dashboard' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const allowedGroups = ["admin","tenant","contributor","author"]

export const isAuthorized = (route: RouteConfig | Route, user: any | null) => {
  if (!route.meta.authorizedTo || route.meta.authorizedTo.length === 0) {
    return true
  }
  if (user == null) return false
  const usersGroups = user.accessToken.payload['cognito:groups'].map(i => i.toLowerCase())
  return route.meta.authorizedTo.some(authorizedTo => usersGroups.includes(authorizedTo))
}

router.beforeEach(async (to, from, next) => {

  let user
  try {
    user = await Auth.currentSession()
    // TODO: check tenant from apollo
    // TODO: if no tenant, mutate from cognito:groups
  } catch (err) {
    await DataStore.clear()
  }

  if (to.name === 'login') {
    try {
      await Auth.currentSession()
      return next(`/dashboard`)
    } catch (err) {
      await DataStore.clear()
      return next()
    }
  }

  if (to.name === 'logout') {
    try {
      await Auth.signOut()
      await DataStore.clear()
      localStorage.removeItem('tenant')
    } catch (err) {
      console.error('Logout failed', err)
    }
    return next('/login')
  }

  if (to.name === 'dashboard') {
    if(!user || !user?.accessToken?.payload['cognito:groups'].some(el => allowedGroups.includes(el.toLowerCase()))) {
      return next(`/logout`)
    }
    if (user?.accessToken?.payload['cognito:groups'].some(el => el.toLowerCase() === "admin")) {
      return next(`/admin`)
    } else {
      return next(`/districts`)
    }
  }

  if (to.meta.authorizedTo) {
    try {
      if (!isAuthorized(to, user)) {
        // TODO: translate text
        mutateSnackbar(
          { text: `Zugriff verweigert.`, color: `error` },
          // @ts-ignore
          router.app.$apollo
        )
        return next('/dashboard')
      } else {
        next()
      }
    } catch (err) {
      // TODO: translate text
      mutateSnackbar(
        { text: `Session abgelaufen. Bitte erneut anmelden.`, color: `error` },
        // @ts-ignore
        router.app.$apollo
      )
      return next(`/logout`)
    }
  } else {
    next()
  }
})

export default router
